export const handleStandaloneUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isAdsApp = urlParams.has('ads');
  const chainParam = urlParams.get('chain');
  if (chainParam) localStorage.setItem('chainParam', chainParam);
  return ({ isAdsApp });
};
